import { Component, OnInit, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AppSettings } from '../../../app.settings';
import { Settings } from '../../../app.settings.model';

@Component({
  selector: 'app-blank',
  templateUrl: './blank.component.html',
  styleUrls: ['./blank.component.scss']
})
export class BlankComponent implements OnInit, AfterViewInit {
  public settings: Settings;
  constructor(public appSettings: AppSettings, public router: Router, public translate: TranslateService) {
    this.settings = this.appSettings.settings;
  }
  ngOnInit() {
    if (localStorage.getItem('lang') === 'ar') this.translate.use('ar');
    else this.translate.use('en');
  }
  ngAfterViewInit() {
    this.settings.loadingSpinner = false;
    setTimeout(() => {
      this.settings.loadingSpinner = false;
    }, 300);
  }
}
